import { useState } from "react";
import Slider from "../components/Slider";
import { MultiSelect } from "react-multi-select-component";
import { participationOptions, occupations, martialStatus, markets, ethnicities, genders } from "../variables/searchOptions";

// Map the arrays
const mappedEthnicities = ethnicities.map((d) => ({ value: d, label: d }));
const mappedMarkets = markets.map((d) => ({ value: d, label: d }));
const mappedMartialStatus = martialStatus.map((d) => ({ value: d, label: d }));
const mappedOccupations = occupations.map((d) => ({ value: d, label: d }));
const mappedParticipationOptions = participationOptions.map((d) => ({ value: d, label: d }));

mappedParticipationOptions.sort((a, b) => {
  const labelA = a.label.toUpperCase();
  const labelB = b.label.toUpperCase();
  if (labelA < labelB) {
    return -1;
  }
  if (labelA > labelB) {
    return 1;
  }
  return 0;
});

const SearchBar = ({
  onSearch,
  querySemantic,
  setQuerySemantic,
  gender,
  genderFuzzy,
  setGenderFuzzy,
  userName,
  setUserName,
  queryExact,
  setQueryExact,
  setGender,
  cutOffDate,
  setCutOffDate,
  ethnicity,
  setEthnicities,
  marital,
  setMarital,
  occupation,
  setOccupation,
  occupationFuzzy,
  setOccupationFuzzy,
  market,
  setMarket,
  marketFuzzy,
  setMarketFuzzy,
  setClient,
  ageValues,
  setAgeValues,
  setIncomeValues,
  blacklist,
  setBlacklist,
  participated,
  setParticipated,
  classes,
  setClasses,
  badclasses,
  setBadClasses,
  loading,
  setPage,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const handleGenderChange = (e) => {
    setGender(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchButtonClick();
    }
  };

  const handleEthnicityChange = (e) => {
    setEthnicities(e.target.value.value);
  };

  const handleMaritalChange = (e) => {
    setMarital(e.target.value);

    // let x = e.map((item) => {
    //   if (typeof item === "string") {
    //     // If the item is a string, use it directly
    //     return item;
    //   } else if (item && typeof item === "object" && item.value) {
    //     // If the item is an object with a 'value' property, use the value property
    //     return item.value;
    //   } else {
    //     // Handle any other cases, such as item being null or not having a 'value' property
    //     return ""; // or any default handling
    //   }
    // });

    // setMarital(x);
  };

  const handleOccupationChange = (e) => {
    setOccupation(e.target.value);
  };

  const handleMarketChange = (e) => {
    console.log("e", e);
    let x = e.map((item) => {
      if (typeof item === "string") {
        // If the item is a string, use it directly
        return item;
      } else if (item && typeof item === "object" && item.value) {
        // If the item is an object with a 'value' property, use the value property
        return item.value;
      } else {
        // Handle any other cases, such as item being null or not having a 'value' property
        return ""; // or any default handling
      }
    });

    setMarket(x);
  };

  const handleClassesChange = (e) => {
    console.log("e", e);
    let x = e.map((item) => {
      if (typeof item === "string") {
        // If the item is a string, use it directly
        return item;
      } else if (item && typeof item === "object" && item.value) {
        // If the item is an object with a 'value' property, use the value property
        return item.value;
      } else {
        // Handle any other cases, such as item being null or not having a 'value' property
        return ""; // or any default handling
      }
    });

    setClasses(x);
  };

  const handleBadClassesChange = (e) => {
    console.log("e", e);
    let x = e.map((item) => {
      if (typeof item === "string") {
        // If the item is a string, use it directly
        return item;
      } else if (item && typeof item === "object" && item.value) {
        // If the item is an object with a 'value' property, use the value property
        return item.value;
      } else {
        // Handle any other cases, such as item being null or not having a 'value' property
        return ""; // or any default handling
      }
    });

    setBadClasses(x);
  };

  const handleClientChange = (e) => {
    setClient(e.target.value);
  };

  const handleSliderChange = (values) => {
    setAgeValues(values);
  };

  const handleIncomeSliderChange = (values) => {
    setIncomeValues(values);
  };

  const handleSearchButtonClick = () => {
    setPage(0);
    onSearch();
  };

  const handleQueryExactInputChange = (e) => {
    setQueryExact(e.target.value);

    e.target.value.length === 0 ? setIsButtonDisabled(true) : setIsButtonDisabled(false);
  };

  const handleOccupationFuzzyInputChange = (e) => {
    setOccupationFuzzy(e.target.value);

    e.target.value.length === 0 ? setIsButtonDisabled(true) : setIsButtonDisabled(false);
  };

  const handleGenderFuzzyInputChange = (e) => {
    setGenderFuzzy(e.target.value);

    e.target.value.length === 0 ? setIsButtonDisabled(true) : setIsButtonDisabled(false);
  };

  const handleMarketFuzzyInputChange = (e) => {
    setMarketFuzzy(e.target.value);

    e.target.value.length === 0 ? setIsButtonDisabled(true) : setIsButtonDisabled(false);
  };

  const handleQuerySemanticInputChange = (e) => {
    setQuerySemantic(e.target.value);

    e.target.value.length === 0 ? setIsButtonDisabled(true) : setIsButtonDisabled(false);
  };

  const handleUserNameInputChange = (e) => {
    setUserName(e.target.value);

    e.target.value.length === 0 ? setIsButtonDisabled(true) : setIsButtonDisabled(false);
  };

  const handleCuttOffChange = (e) => {
    setCutOffDate(e.target.value);
  };

  return (
    <div className="container mx-auto text-center ">
      <div className="flex flex-row">
        <div className="flex flex-col w-full">
          <div className="flex flex-col w-full ">
            <div className="prose mx-auto text-center py-5">
              <h1 className>User Search:</h1>
            </div>
            <div className="items-center mb-0">
              <label>Name or Email:</label>
              <input type="text" placeholder="" className="select select-bordered w-full bg-none text-black" value={userName} onChange={handleUserNameInputChange} onKeyPress={handleKeyPress} />
            </div>
          </div>
          <div className="divider"></div>

          <div className="flex flex-col w-full">
            <div className="prose mx-auto text-center py-5">
              <h1 className>Bio Search:</h1>
            </div>
            <div className="items-center mb-0">
              <label>Exact:</label>
              <input type="text" placeholder="Name" className="select select-bordered w-full bg-none text-black" value={queryExact} onChange={handleQueryExactInputChange} onKeyPress={handleKeyPress} />
            </div>
            <div className="">
              <div className="items-center mb-0">
                <label>Semantic:</label>
                <input type="text" placeholder="Search" className="select select-bordered w-full bg-none text-black" value={querySemantic} onChange={handleQuerySemanticInputChange} onKeyPress={handleKeyPress} />
              </div>
            </div>
          </div>

          <div className="divider"></div>

          <div className="flex flex-col  w-full gap-1">
            <div className="prose mx-auto text-center py-5">
              <h1 className>Demographics:</h1>
            </div>
          </div>
          <div>
            <label>Gender:</label>
            <select onChange={(e) => handleGenderChange(e)} className="select select-bordered w-full " defaultValue="">
              <option value="" key="Gender" disabled>
                Gender
              </option>
              <option value="" key="Any">
                Any
              </option>
              {genders.map((d) => (
                <option value={d} key={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>
          <div className="items-center mb-0">
            <label>Gender Contains:</label>
            <input type="text" placeholder="Name" className="select select-bordered w-full bg-none text-black" value={genderFuzzy} onChange={handleGenderFuzzyInputChange} onKeyPress={handleKeyPress} />{" "}
          </div>
          <div>
            <label>Ethnicities:</label>
            <MultiSelect options={mappedEthnicities} value={ethnicity} onChange={setEthnicities} labelledBy={"Select Nice Classes"} isCreatable={false} hasSelectAll={true} className="pb-5 light" />
          </div>
          <div>
            <label>Marital Status:</label>
            <MultiSelect options={mappedMartialStatus} value={marital} onChange={setMarital} labelledBy={"Select Marital Statuses"} isCreatable={false} hasSelectAll={true} className="pb-5 light" />
          </div>

          <div>
            <label>Market:</label>
            <MultiSelect options={mappedMarkets} value={market} onChange={setMarket} labelledBy={"Select Markets"} isCreatable={false} hasSelectAll={true} className="pb-5 light" />
          </div>
          <div className="items-center mb-0">
            <label>Market Contains:</label>
            <input type="text" placeholder="Name" className="select select-bordered w-full bg-none text-black" value={marketFuzzy} onChange={handleMarketFuzzyInputChange} onKeyPress={handleKeyPress} />{" "}
          </div>
          <div>
            <label>Occupation:</label>
            <select onChange={(e) => handleOccupationChange(e)} className="select select-bordered w-full" defaultValue="">
              <option value="" disabled>
                Occupation
              </option>
              <option value="">Any</option>
              {occupations.map((d) => (
                <option value={d} key={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>
          <div className="items-center mb-0">
            <label>Occupation Contains:</label>
            <input type="text" placeholder="Name" className="select select-bordered w-full bg-none text-black" value={occupationFuzzy} onChange={handleOccupationFuzzyInputChange} onKeyPress={handleKeyPress} />{" "}
          </div>
          <div className="">
            <div className="">
              <label>Age:</label>
              <Slider onSliderChange={handleSliderChange} marks={true} label={"Age"} low={16} high={80} step={1} min={0} max={110} isLogarithmic={false} />
            </div>
            <br />
            <div className="">
              <label>Household Income:</label>

              <Slider onSliderChange={handleIncomeSliderChange} label={"Income"} low={25000} high={100000} step={10000} min={0} max={1000000} isLogarithmic={false} />
            </div>
          </div>
          <div className="flex flex-col gap-5 w-full">
            <div className="divider"></div>

            <div className="prose mx-auto text-center py-5">
              <h1 className>Casting Lists:</h1>
            </div>
            <div className="form-control">
              <label>Exclude users who have participated in a project after:</label>
              <input type="text" placeholder="" className="select select-bordered w-full bg-none text-black" value={cutOffDate} onChange={handleCuttOffChange} onKeyPress={handleKeyPress} />
            </div>
            <div className="form-control">
              <label className="label cursor-pointer">
                <span className="label-text">Blacklisted People: No/Yes</span>
                <input type="checkbox" className="toggle" checked={blacklist} onChange={() => setBlacklist(!blacklist)} />
              </label>
            </div>
          </div>
          <div>
            <label>Include if they participated in these projects:</label>
            <MultiSelect options={mappedParticipationOptions} value={classes} onChange={setClasses} labelledBy={"Participated Projects"} isCreatable={false} hasSelectAll={true} className="pb-5 light" />
          </div>
          <div>
            <label>Exclude if they participated in these projects:</label>
            <MultiSelect options={mappedParticipationOptions} value={badclasses} onChange={setBadClasses} labelledBy={"Select Nice Classes"} isCreatable={false} hasSelectAll={true} className="pb-5 light" />
          </div>
          <div className="divider"></div>

          <button className="btn btn-primary ml-2" onClick={handleSearchButtonClick} disabled={loading}>
            {/* isButtonDisabled || loading */}
            {loading ? (
              <span className="animate-spin">
                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </span>
            ) : (
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
